import axios from 'axios'
import { LanguageRestClient } from 'http/resources'
import { ErrorManager } from 'services'

function getLanguages(page, pageCount, criteria) {
    return async dispatch => {
        try {
            dispatch({
                type: 'LANGUAGES_FETCH_LANGUAGES_START',
                payload: {
                    isActiveSearch: typeof criteria !== 'undefined',
                }
            })
            
            const response = await new LanguageRestClient(true).getLanguages(page, pageCount, criteria)

            dispatch({
                type: 'LANGUAGES_FETCH_LANGUAGES_SUCCESS',
                payload: {
                    page,
                    pageCount,
                    languages: response.data.items,
                    totals: response.data.totalItems,
                }
            })
            
        } catch (e) {
            if (e instanceof axios.Cancel) {
                // Nothing to do, just canceled request by next request
            } else {
                dispatch({
                    type: 'LANGUAGES_FETCH_LANGUAGES_FAIL'
                })
    
                dispatch({
                    type: 'ERROR_SET',
                    payload: {
                        title: 'Error en la operación!',
                        description: 'Ha ocurrido un error al intentar obtener los lenguajes'
                    }
                })
            }
        }   
    }
}

function getLanguage(id) {
    return async dispatch => {
        try {
            dispatch({
                type: 'LANGUAGES_FETCH_LANGUAGE_START'
            })

            const response = await new LanguageRestClient(true).getLanguage(id)

            dispatch({
                type: 'LANGUAGES_FETCH_LANGUAGE_SUCCESS',
                payload: {
                    language: response.data
                }
            })
        } catch (e) {
            dispatch({
                type: 'LANGUAGES_FETCH_LANGUAGE_FAIL'
            })

            dispatch({
                type: 'ERROR_SET',
                payload: {
                    title: 'Error en la operación!',
                    description: 'Ha ocurrido un error al intentar obtener el lenguaje'
                }
            })
        }
    }
}

function saveLanguage(id, data, patch) {
    return async dispatch => {
        try {
            dispatch({
                type: 'LANGUAGES_SAVE_LANGUAGE_START',
                payload: {
                    id,
                    patch,
                }
            })

            if (id && !patch) {
                await new LanguageRestClient(true).updateLanguage(id, data)
            } else if (id && patch) {
                await new LanguageRestClient(true).patchLanguage(id, data)
            } else {
                await new LanguageRestClient(true).createLanguage(data)
            }

            dispatch({
                type: 'LANGUAGES_SAVE_LANGUAGE_SUCCESS',
                payload: {
                    id,
                    data,
                    patch,
                }
            })

            dispatch({
                type: 'SUCCESS_SET',
                payload: {
                    title: 'Operación Exitosa!',
                    description: id
                        ? 'El idioma se ha actualizado correctamente'
                        : 'El idioma se ha creado correctamente'
                }
            })
        } catch (e) {
            dispatch({
                type: 'LANGUAGES_SAVE_LANGUAGE_FAIL'
            })

            dispatch({
                type: 'ERROR_SET',
                payload: {
                    title: 'UPS! Ha ocurrido un error en la operación.',
                    description: ErrorManager.toMessage(e),
                }
            })
        } finally {
            dispatch({
                type: 'LANGUAGES_SAVE_LANGUAGE_RESET'
            })
        }
    }
}

function setFormPropertyValue(property, value) {
    return {
        type: 'LANGUAGES_FORM_PROPERTY_VALUE_SET',
        payload: {
            property,
            value
        }
    }
}

function reset(type) {
    return {
        type,
    }
}


export const LanguagesActions = {
    getLanguages,
    getLanguage,
    saveLanguage,
    setFormPropertyValue,
    reset,
}